import React, { useEffect, useRef } from "react";
import { Box, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const Notification = ({ isOpen, onClose, position }) => {
  const notificationRef = useRef(null);
  const width = 250; // Set a fixed width

  // Close notification if clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        notificationRef.current &&
        !notificationRef.current.contains(event.target)
      ) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <Box
      ref={notificationRef}
      sx={{
        position: "absolute",
        top: position.top + 70, // Below the icon
        right: Math.max(0, position.left - width / 2), // Centered under icon, prevent left overflow
        width: width,
        minWidth: 200,
        maxWidth: 300,
        padding: 2,
        bgcolor: "white",
        boxShadow: 3,
        borderRadius: 2,
        zIndex: 10,
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="body1" fontWeight="bold">
          New notifications
        </Typography>
        <IconButton onClick={onClose} size="small">
          <CloseIcon fontSize="small" />
        </IconButton>
      </Box>

      <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
        Welcome to QuickCard
      </Typography>
    </Box>
  );
};

export default Notification;
